var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "view-action-list" },
    [
      _c(
        "cms-heading",
        { attrs: { title: "Actielijst", level: "2" } },
        [
          _c("cms-dropdown", {
            staticStyle: { "min-width": "250px" },
            attrs: {
              placeholder: "Status wijzigen (max. 25 acties)...",
              options: _vm.stateOptions,
            },
            on: { input: _vm.updateState },
          }),
          _vm.isAdminOrAdvisor
            ? _c(
                "cms-button",
                {
                  attrs: { icon: "magicon-jump-right-up" },
                  on: {
                    click: function ($event) {
                      return _vm.exportActions()
                    },
                  },
                },
                [_vm._v("Exporteer acties")]
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "cms-table-panel",
        {
          directives: [
            {
              name: "spinner",
              rawName: "v-spinner",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          attrs: {
            "item-count": _vm.actions.totalCount || 0,
            "items-per-page": _vm.itemsPerPage,
            offset: _vm.offset,
            placeholder: !_vm.actions.items || !_vm.actions.items.length,
            clickable: "true",
          },
          on: {
            page: function ($event) {
              _vm.offset = arguments[0]
            },
          },
        },
        [
          _c(
            "cms-table-header",
            [
              _c(
                "cms-th",
                {
                  attrs: { field: "loggerId" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Logger")]
              ),
              _c("cms-th", [_vm._v("Type")]),
              _c(
                "cms-th",
                {
                  attrs: { field: "projectId" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Project")]
              ),
              _c(
                "cms-th",
                {
                  attrs: { field: "locationTitle" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Locatie WWD")]
              ),
              _c(
                "cms-th",
                {
                  attrs: { field: "measuringPoint" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Meetpunt")]
              ),
              _c(
                "cms-th",
                {
                  attrs: { field: "issueDate" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Datum van probleem")]
              ),
              _c(
                "cms-th",
                {
                  attrs: { field: "deadline" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Deadline")]
              ),
              _c(
                "cms-th",
                {
                  attrs: { field: "state" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Status")]
              ),
              _c(
                "cms-th",
                {
                  attrs: { field: "categories" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Categorieën kantoor")]
              ),
              _c(
                "cms-th",
                {
                  attrs: { field: "commentsOffice" },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                },
                [_vm._v("Opm. kantoor")]
              ),
              _vm.isAdminOrAdvisor
                ? _c(
                    "cms-th",
                    {
                      attrs: { field: "categoriesField" },
                      model: {
                        value: _vm.sort,
                        callback: function ($$v) {
                          _vm.sort = $$v
                        },
                        expression: "sort",
                      },
                    },
                    [_vm._v("Categorieën veld")]
                  )
                : _vm._e(),
              _vm.isAdminOrAdvisor
                ? _c(
                    "cms-th",
                    {
                      attrs: { field: "commentsField" },
                      model: {
                        value: _vm.sort,
                        callback: function ($$v) {
                          _vm.sort = $$v
                        },
                        expression: "sort",
                      },
                    },
                    [_vm._v("Opm. veld")]
                  )
                : _vm._e(),
              _c("cms-th"),
            ],
            1
          ),
          _vm._l(_vm.actions.items, function (action) {
            return _c(
              "tr",
              {
                on: {
                  click: function ($event) {
                    return _vm.showAction(action)
                  },
                },
              },
              [
                _c(
                  "td",
                  [
                    _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            name: "action-view",
                            params: { id: action.id },
                          },
                        },
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                          },
                        },
                      },
                      [_vm._v(_vm._s(action.logger.serialNumber))]
                    ),
                  ],
                  1
                ),
                _c("td", [_vm._v(_vm._s(action.logger.type.title))]),
                _c("td", [_vm._v(_vm._s(action.project.code))]),
                _c("td", [
                  _vm._v(_vm._s(_vm._f("empty")(action.locationTitle))),
                ]),
                _c("td", [_vm._v(_vm._s(action.measuringPoint))]),
                _c("td", [
                  _vm._v(_vm._s(_vm._f("date")(action.issueDate, "LL"))),
                ]),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      _vm._f("date")(
                        _vm._f("actionDeadlineDate")(
                          action.deadline,
                          action.issueDate
                        ),
                        "LL"
                      )
                    )
                  ),
                ]),
                _c(
                  "td",
                  [
                    _c("cms-text-label", {
                      attrs: {
                        title: _vm._f("actionState")(action.state),
                        color: _vm._f("actionStateColor")(action.state),
                      },
                    }),
                  ],
                  1
                ),
                _c("td", [
                  _vm._v(_vm._s(_vm.parseCategories(action.categories))),
                ]),
                _c("td", [_vm._v(_vm._s(action.commentsOffice))]),
                _vm.isAdminOrAdvisor
                  ? _c("td", [
                      _vm._v(
                        _vm._s(_vm.parseCategories(action.categoriesField))
                      ),
                    ])
                  : _vm._e(),
                _vm.isAdminOrAdvisor
                  ? _c("td", [_vm._v(_vm._s(action.commentsField))])
                  : _vm._e(),
                _c(
                  "td",
                  {
                    staticClass: "actions",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                    },
                  },
                  [
                    _c(
                      "router-link",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: "Bekijken",
                            expression: "'Bekijken'",
                          },
                        ],
                        attrs: {
                          to: {
                            name: "action-view",
                            params: { id: action.id },
                          },
                        },
                      },
                      [_c("i", { staticClass: "entypo-eye" })]
                    ),
                    _c(
                      "router-link",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: "Wijzigen",
                            expression: "'Wijzigen'",
                          },
                        ],
                        attrs: {
                          to: {
                            name: "action-edit",
                            params: { id: action.id },
                          },
                        },
                      },
                      [_c("i", { staticClass: "magicon-edit" })]
                    ),
                  ],
                  1
                ),
              ]
            )
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }